module.exports = __webpack_public_path__ + "assets/f41db37adb59f4f29b2cf388ce5cd90c.mp3";